import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { PlanStatusEnum } from 'APIPackage/PlanListModule/enums/PlanStatusEnum';

export const planStatusesOptions: ISelectOption[] = [
  { id: PlanStatusEnum.NEW, label: 'Новый', value: PlanStatusEnum.NEW },
  { id: PlanStatusEnum.IN_REVISION, label: 'Отправлен на согласование', value: PlanStatusEnum.IN_REVISION },
  { id: PlanStatusEnum.IN_AGREEMENT, label: 'Отправлен на доработку', value: PlanStatusEnum.IN_AGREEMENT },
  { id: PlanStatusEnum.AGREED, label: 'Согласован', value: PlanStatusEnum.AGREED },
  { id: PlanStatusEnum.APPROVED, label: 'Утверждён', value: PlanStatusEnum.APPROVED },
];
